import React from "react";

export default function WalletIcon({className}) {
  return (
    <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <g id="vuesax/bold/wallet-3">
        <g id="wallet-3">
          <path
            id="Vector"
            d="M22.1999 12.62V14.68C22.1999 15.24 21.7399 15.7 21.1699 15.7H19.2399C18.1599 15.7 17.1699 14.91 17.0799 13.83C17.0199 13.2 17.2599 12.61 17.6799 12.2C18.0499 11.82 18.5599 11.6 19.1199 11.6H21.1699C21.7399 11.6 22.1999 12.06 22.1999 12.62Z"
            fill="#292D32"
          />
          <path
            id="Vector_2"
            d="M15.58 13.96C15.49 12.91 15.87 11.88 16.63 11.13C17.27 10.48 18.16 10.1 19.12 10.1H19.69C19.97 10.1 20.2 9.86999 20.16 9.58999C19.8899 7.64999 18.21 6.14999 16.2 6.14999H6.19995C3.98995 6.14999 2.19995 7.93999 2.19995 10.15V17.15C2.19995 19.36 3.98995 21.15 6.19995 21.15H16.2C18.22 21.15 19.8899 19.65 20.16 17.71C20.2 17.43 19.97 17.2 19.69 17.2H19.24C17.34 17.2 15.74 15.78 15.58 13.96ZM13.2 11.9H7.19995C6.78995 11.9 6.44995 11.57 6.44995 11.15C6.44995 10.73 6.78995 10.4 7.19995 10.4H13.2C13.61 10.4 13.95 10.74 13.95 11.15C13.95 11.56 13.61 11.9 13.2 11.9Z"
            fill="#292D32"
          />
          <path
            id="Vector_3"
            d="M14.4099 3.98001C14.6699 4.25001 14.4399 4.65001 14.0599 4.65001H6.22986C5.13986 4.65001 4.11986 4.97001 3.26986 5.52001C2.87986 5.77001 2.34986 5.50001 2.53986 5.07001C3.09986 3.76001 4.40986 2.85001 5.91986 2.85001H11.5399C12.6999 2.85001 13.7299 3.26001 14.4099 3.98001Z"
            fill="#292D32"
          />
        </g>
      </g>
    </svg>
  );
}
